
import NGError from '../../../error/ngError';
import errorFactory from '../../../error/errorFactory';
import {
	WS_REQUEST_IS_MALFORMED,
	WS_PROCESS_MESSAGE_IS_MALFORMED,
} from '../../../error/websocket/errorTypes';
import { publishAndAwait } from '../../../app/coreSlice';

export const addOrRemoveZoneToPP = async ( data, subType ) => {

	if (typeof data === 'undefined') {
		throw errorFactory(WS_REQUEST_IS_MALFORMED);
	};

	const {
		pricingPlanId,
		zoneId,
	} = data;
	
	if ( !pricingPlanId || !zoneId || !subType ) {
		throw errorFactory(WS_REQUEST_IS_MALFORMED);
	};

	const request = await publishAndAwait({
		destination: '/app/hello',
		body: {
			type: 'PRICING_PLAN',
			subType,
			message: {
				pricingPlanId,
				zoneId,
			},
		},
	});

	const { processMessage, error } = request.response;

	if (error) {
		return;
	}

	if (!processMessage) {
		throw errorFactory(WS_PROCESS_MESSAGE_IS_MALFORMED);
	}

	if (error) {

		const {
			description,
			code,
			tag,
		} = processMessage;

		throw new NGError({
			message: description,
			code,
			tag,
		});
	}

	return processMessage || null;
};

export default addOrRemoveZoneToPP;